import { useMemo } from 'react';

const useReducedErrors = errors => {
  const {
    details
  } = errors;

  const errorsReduced = useMemo(() => (
    details
      ? details.reduce((prev, curr) => {
        const {
          context: {
            key
          },
          message
        } = curr;

        prev[key] = message;

        return prev;
      }, {})
      : {}
  ), [details]);

  return errorsReduced;
};

export default useReducedErrors;
